import { getApexDomain } from "@/helpers/url";

export function getCookie(name: string) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * Encodes a value for storage in a cookie
 * @name encodeCookieValue
 * @param value - the object to encode
 * @returns a base64-encoded string
 */

export function encodeCookieValue(value: Object) {
  return btoa(JSON.stringify(value));
}

export function decodeCookieValue(value: string) {
  return JSON.parse(atob(value));
}

export function setCookie(name: string, value: string, maxAge?: number) {
  let expires = "";
  if (maxAge) expires = "; max-age=" + `${maxAge}`;
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export function deleteCookie(name: string) {
  document.cookie = `${name}=; expires=${new Date()}; path=/`;
}

/** Apex domains where domain cookies should NOT be set, as it can cause issues across tenants who haven't set a custom apex domain */
const RESTRICTED_APEX_DOMAINS = ["upmind.app", "upmind.dev", "upmind.com"];

export function setDomainCookie(name: string, value: string, maxAge?: number) {
  const domain = getApexDomain();
  let expires = "";
  if (maxAge) expires = "; max-age=" + `${maxAge}`;

  // Prevent setting domain cookies on restricted apex domains
  if (RESTRICTED_APEX_DOMAINS.includes(domain)) {
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
    return;
  }

  document.cookie =
    name + "=" + (value || "") + expires + "; path=/; domain=" + domain;
}

export function deleteDomainCookie(name: string) {
  const domain = getApexDomain();
  document.cookie = `${name}=; max-age=0; path=/; domain=${domain}`;
}
